
import bonusFrame from '../../../assets/bonus-frame.png';
import { RegisterLink } from '../../../components/RegisterLink';

const bonusItems = [
  'Daily Rollover Rebate 0.9%',
  'Golden Egg Bonus AUD ?',
  'Daily Easy Step Free AUD 100',
  'Unlimited Random Bonus AUD ?',
  'Free 365 Days Bonus AUD ?',
  'Weekly Commission 5%',
];

const UpcomingMatches = () => {
  return (
    <div className="mt-10 md:mt-12 mb-6">
      <div className="flex items-center justify-between mb-3">
        <h2 className="text-2xl sm:text-2xl md:text-3xl font-bold text-white" style={{ fontFamily: 'Orbitron, sans-serif' }}>
          Kingbet9 Hot Promotions Bonus
        </h2>
      </div>
      <h3 className="text-sm md:text-base font-semibold text-yellow-300 mb-1">Kingbet9 Daily and Weekly Casino Bonuses</h3>
      <h4 className="text-xs md:text-sm font-medium text-gray-400 mb-3">Kingbet9 Australia Bonus Offers</h4>

      <div className="grid grid-cols-3 md:grid-cols-6 gap-2 md:gap-2">
        {bonusItems.map((title) => (
          <RegisterLink
            key={title}
            source="hot_promotions_bonus"
            label={title}
            className="relative flex items-center justify-center"
          >
            <img
              src={bonusFrame}
              alt="Bonus frame"
              className="w-full max-w-[110px] md:max-w-[120px] h-auto object-contain transition-transform duration-300 hover:scale-[1.03]"
            />
            <div className="absolute inset-0 flex items-center justify-center p-2 md:p-2">
              <p
                className="text-center text-yellow-400 font-black text-[11px] md:text-xs leading-tight max-w-[70%] whitespace-normal break-words drop-shadow-[0_2px_8px_rgba(0,0,0,0.85)]"
                style={{ fontFamily: 'Orbitron, sans-serif' }}
              >
                {title}
              </p>
            </div>
          </RegisterLink>
        ))}
      </div>
    </div>
  );
};

export default UpcomingMatches;
